import React from 'react';
import { useSchedulesQuery } from 'features/events/queries';
import { useScheduleContext } from 'features/events/context/ScheduleContext';
import { SchedulePanelProvider } from 'features/events/SchedulePanelContext';
import BetsAreaForSchedule from 'features/markets/components/BetsAreaEventWrapper';
import { cn } from 'lib/utils';
import type { Schedule } from 'features/events/types';

function filterAvailableSchedules(schedules: Schedule[]) {
  const list = Array.isArray(schedules) ? schedules : [];
  return list.filter((schedule) => {
    const sportObj = schedule?.sport;
    return (
      sportObj &&
      (sportObj.active === true ||
        sportObj.active === 1 ||
        parseInt(String(sportObj.active)) === 1)
    );
  });
}

export default function AllSchedulePanels() {
  const { data: schedules = [] } = useSchedulesQuery();
  const current_schedule_id = useScheduleContext().currentScheduleId;

  const available_schedules = React.useMemo(
    () => filterAvailableSchedules(schedules),
    [schedules]
  );

  return (
    <div className="w-full h-full min-h-0 flex flex-col">
      {available_schedules.map((schedule) => {
        const scheduleId = schedule.schedule_id;
        const isCurrent = current_schedule_id != null && current_schedule_id === scheduleId;
        return (
          <div
            key={scheduleId}
            className={cn(
              'w-full min-h-0',
              isCurrent ? 'h-full flex flex-col' : 'hidden'
            )}
            aria-hidden={!isCurrent}
          >
            <SchedulePanelProvider scheduleId={scheduleId}>
              <BetsAreaForSchedule />
            </SchedulePanelProvider>
          </div>
        );
      })}
    </div>
  );
}
